/* unplugin-vue-components disabled */import script from "./albumItem.vue?vue&type=script&setup=true&name=albumItem&lang=js"
export * from "./albumItem.vue?vue&type=script&setup=true&name=albumItem&lang=js"

import "./albumItem.vue?vue&type=style&index=0&id=2f41c8e3&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f41c8e3"]])

export default __exports__